import {
    BalanceSheet as BalanceSheetCard,
    CashFlow as CashFlowCard,
    KeyRatios as KeyRatiosCard,
    IncomeStatement as IncomeStatementCard
} from "../Cards";

export default function Equity({incomeStatement, keyRatios, cashFlow, balanceSheet, quote}) {

    return <div className="ajb-grid-row margin-top-20">
        <div className="ajb-col-collapse">
            <div className="ajb-col-12 ajb-col-8-breakpoint">	

                <div className="ab-grid-row clearfix"> 
                    <div className="ajb-col-collapse"> 
                        <IncomeStatementCard incomeStatement={incomeStatement} quote={quote} />
                    </div>
                </div>

                <div className="ab-grid-row clearfix"> 
                    <div className="ajb-col-collapse"> 
                        <BalanceSheetCard balanceSheet={balanceSheet} quote={quote} />                  
                    </div>
                </div>

                <div className="ab-grid-row clearfix"> 
                    <div className="ajb-col-collapse"> 
                        <CashFlowCard cashFlow={cashFlow} quote={quote} />                
                    </div>
                </div>

                <div className="ab-grid-row clearfix"> 
                    <div className="ajb-col-collapse">
                        <KeyRatiosCard keyRatios={keyRatios} quote={quote} isSummary={true} />
                    </div>
                </div>

                {incomeStatement.length && incomeStatement[0].currency ? <p data-testid="summaryCurrencyInMillionsText">{incomeStatement[0].currency} in millions except per share data.</p>: null}
            </div>            
        </div>
    </div>
    
    
}